/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createAcot } from '../../factoriesAny.js';
export var acotDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  typedDependencies: typedDependencies,
  createAcot: createAcot
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAcot.generated.js
// module id = 1338
// module chunks = 0